import PhoneNumberInputItem from "../../@richbeauty/core/AppFormModal/AppFormItems/PhoneNumberInputItem";

const ComponentCore = () => <PhoneNumberInputItem />;
export default ComponentCore;
